<script type="text/ecmascript-6">
    import DesignerQuestionGlassBackingDesign from "./DesignerQuestionGlassBackingDesign.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionGlassBackingDesign,
            SynsealQuestion,
        ],
    }
</script>
